"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// import {
//   ISuccessfulIndexResponse,
//   ISuccessfulPostResponse,
//   ISuccessfulGetResponse,
//   ISuccessfulPutResponse
// } from "../../types";
var TermsAndConditions = /** @class */ (function () {
    function TermsAndConditions(recover) {
        var _this = this;
        this.recover = recover;
        this.get = function () {
            return _this.recover.request("/termsandconditions", "GET", null, null);
        };
    }
    return TermsAndConditions;
}());
exports.default = TermsAndConditions;
